import { Injectable } from '@angular/core';
import { LocationType } from '@rtls/core/models/location/location-type.model';
import { Pagination } from '@rtls/core/models/rpc/pagination.model';

import { RtlsModels } from '@rtls/core/models/rtls/rtls-models';
import { RtlsServiceDecorator } from '@rtls/core/models/rtls/rtls-service.decorator';
import { RtlsService } from '@rtls/core/models/rtls/rtls-service.model';
import { Facet } from '@rtls/core/models/shared/filter/facet.model';
import { sortBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { flatMap, map, toArray } from 'rxjs/operators';

@Injectable()
export class LocationTypeService extends RtlsServiceDecorator<LocationType> {
	constructor(rtlsService: RtlsService<LocationType>) {
		super(rtlsService.useModel(RtlsModels.LocationType));
	}

	public getLocationTypes(pagination?: Pagination): Observable<LocationType[]> {
		return this.getAll(pagination).pipe(map((data) => data.data));
	}

	public getLocationTypesFacets(): Observable<Facet[]> {
		return this.getLocationTypes().pipe(
			flatMap((locationTypes: LocationType[]) => locationTypes),
			map((locationType: LocationType) => new Facet(locationType.key, <string>locationType.translation)),
			toArray(),
			map((facets) => sortBy(facets, [(facet) => facet.getTranslation()?.toString().toLowerCase()])),
		);
	}
}
